import React from 'react';
import styled from 'styled-components';
import { Antd3Input, Antd3Form, Antd3InputProps } from '../antd3';
import { DynamicFieldSetItemProps } from './DynamicFieldSet';

const InterimDateWrapper = styled.div`
    width: 100%;
`;

type Props = Antd3InputProps & DynamicFieldSetItemProps;

export const InterimLink: React.FC<Props> = ({
    form,
    id,
    fullId,
    onInputChange,
    url,
    label,
}: Props) => {
    const handleInputUpdate = (fieldName: string, value: string) => {
        if (onInputChange) {
            onInputChange(id, fieldName, value);
        }
    };

    return (
        <InterimDateWrapper>
            <Antd3Form.Item required={false}>
                <Antd3Input
                    form={form}
                    id={`${fullId}[url]`}
                    getFieldDecoratorOptions={{
                        initialValue: url,
                    }}
                    size="large"
                    placeholder="URL"
                    label={label}
                    onChange={(event) => handleInputUpdate('url', event.target.value)}
                />
            </Antd3Form.Item>
        </InterimDateWrapper>
    );
};
